import { t as __exportAll } from "./chunk-rolldown-runtime.mjs";
//#region src/providers/memory.ts
var memory_exports = /* @__PURE__ */ __exportAll({
	foldBreakdown: () => foldBreakdown,
	measureCrossRealmMemory: () => measureCrossRealmMemory,
	readHeap: () => readHeap,
	supportsCrossRealmMemory: () => supportsCrossRealmMemory
});
/** Chromium-only and main-thread-only, hence the feature test rather than a direct read. */
var readHeap = () => {
	const memory = globalThis.performance?.memory;
	if (!memory) return {};
	return {
		used: memory.usedJSHeapSize,
		total: memory.totalJSHeapSize,
		limit: memory.jsHeapSizeLimit
	};
};
/** True when `measureUserAgentSpecificMemory` is available; it needs cross-origin isolation. */
var supportsCrossRealmMemory = () => typeof globalThis.performance?.measureUserAgentSpecificMemory === "function";
/**
* Cross-realm usage — the only view of the shared and dedicated workers, since `performance.memory`
* reports the calling realm alone. Resolves only after a GC, so sample it off the collection path.
*/
var measureCrossRealmMemory = async () => {
	const performanceWithMemory = globalThis.performance;
	const measure = performanceWithMemory?.measureUserAgentSpecificMemory;
	if (!measure) return;
	return foldBreakdown((await measure.call(performanceWithMemory)).breakdown);
};
/** Folds a breakdown into per-realm totals; unattributed cost buckets to `other` so scopes still sum to the total. */
var foldBreakdown = (breakdown) => {
	const totals = {};
	for (const entry of breakdown) {
		const scope = toScope(entry.attribution[0]?.scope);
		totals[scope] = (totals[scope] ?? 0) + entry.bytes;
	}
	return totals;
};
var toScope = (scope) => {
	switch (scope) {
		case "Window": return "window";
		case "SharedWorkerGlobalScope": return "shared-worker";
		case "DedicatedWorkerGlobalScope": return "dedicated-worker";
		default: return "other";
	}
};
//#endregion
export { supportsCrossRealmMemory as i, memory_exports as n, readHeap as r, measureCrossRealmMemory as t };

//# sourceMappingURL=chunk-memory.mjs.map